import React, { useRef } from 'react'
import { observer } from 'mobx-react'
import t from '../../service/translate.service'
import { Checkbox } from '../../components/formComponents'
import { CheckIcon } from '../../components/icons'
import { Form, Button } from 'react-bootstrap'
import PropTypes from 'prop-types'
import contractService from '../../service/contract.service'
import { Alert } from 'antd'

const LoyaltyRegistrationForm = observer(({ store, contracts, contractSelect }) => {
  const { model, validators, setVal, onSubmit, contractSelected, errorsList, submitted, errorListVoice, alertValidators } = store
  const inputRefs = useRef([])
  const AlertContent = () => {
    return (
    <div
        className='error-list'
        role={errorListVoice ? "alert" : "none"}
        aria-live={errorListVoice ? "assertive" : "off"}
      >
        {t.REQUIRED_FIELD_MISSING}
        {errorsList?.map((err, index) => {
          return (
            <button key={index} type='button' onClick={() => {
              inputRefs.current[err.index].focus()
            }}>{err.err}</button>
          )
        })}
      </div>
    )
  }
  return (
    <Form>
      {errorsList?.length > 0 && submitted && (
        <Alert
          message={<AlertContent />}
          type='error'
          role={errorListVoice ? "alert" : "none"}
          style={{ marginTop: '12px', marginBottom: '12px' }}
        />
      )}

      <Form.Group>
        <label className='form-label'>{`${t.CONTRACT_LIST_TITLE} *`}</label>
        {contracts.map((contract, index) => {
          if(contractService.checkIsContractCondominium(contract?.contractNumber)) return
          return (
            <ContractCard
              ref={(el) => {
                if (index === 0) {
                  inputRefs.current[0] = el
                }
              }}
              key={contract.id}
              contract={contract}
              handleClick={contractSelect}
              active={model.contractNumber === contract.contractNumber}
              onBlur={() => {
                if (!contractSelected) {
                  store.contractCardBlur = true
                } else {
                  store.contractCardBlur = false
                }
              }}
            />
              
          )
        })}
        {(contractSelected || store.contractCardBlur) && (<div className='error-message loyalty-contract'>{t.NO_CONTRACT_SELECTED_ERROR}</div>)}
      </Form.Group>

      <Checkbox
        ref={(el) => (inputRefs.current[1] = el)}
        labelBeforeText={t.LOYALTY_TERMS_AND_CONDITIONS_1}
        labelAfterText={' *'}
        labelLinkText={`${t.LOYALTY_TERMS_AND_CONDITIONS_2}`}
        labelLink='terms-and-conditions'
        helperLabel='terms-and-conditions-loyalty'
        value={model.terms}
        onChange={e => setVal('terms', !model.terms)}
        error={t.TERMS_AND_CONDITIONS_REQUIRED}
        validate={validators['terms']}
        blurValidate={alertValidators['terms']}
      />

      <Form.Group className='actions text-center'>
        <div className='group'>
          <button
            href=''
            onClick={(e) => {
              onSubmit(e)
            }}
            type='submit'
            className='button primary'
          >
            {t.LOYALTY_REGISTER}
          </button>
        </div>
      </Form.Group>
    </Form>
  )
})

LoyaltyRegistrationForm.propTypes = {
  store: PropTypes.object,
  contracts: PropTypes.object,
  contractSelect: PropTypes.func
}
const ContractCard = React.forwardRef(({ contract, handleClick, active, onBlur }, ref) => {
  return (
    <button
      ref={ref}
      onBlur={onBlur}
      className={`loyalty-contract-card ${active && 'active'}`}
      onClick={(e) => {
        if (e.key !== 'Tab') {
          e.preventDefault()
        }
        handleClick(contract.contractNumber)
      }}
      role="button" 
      aria-pressed={active ? "true" : "false"}
      tabIndex={0}
    >
      <div>
        <p className='number'>{contract.contractNumber}</p>
        <p>{contract.address}</p>
      </div>
      <div className='check'>
        <div>{CheckIcon}</div>
      </div>
    </button>
  )
})

ContractCard.propTypes = {
  contract: PropTypes.object,
  handleClick: PropTypes.func,
  active: PropTypes.bool
}
export default LoyaltyRegistrationForm
